<section class="auth-shell orb_brand">
  
  <div class="auth-shell__layout">
    <aside class="auth-shell__brand">
      <div class="orb o1"></div>
  <div class="orb o2"></div>
  <div class="orb o3"></div>
  <div class="orb o4"></div>
      <div class="auth-shell__brand-top">
        <div class="auth-shell__brand-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 2L4 6v6c0 5.25 3.4 10.15 8 11.45C16.6 22.15 20 17.25 20 12V6L12 2zm-1 14l-3-3 1.41-1.41L11 13.17l4.59-4.58L17 10l-6 6z"
            />
          </svg>
        </div>
        <div class="auth-shell__brand-name">MindYourTax</div>
      </div>

      <div class="auth-shell__hero">
        <div class="auth-shell__hero-art">
          <ng-lottie [options]="heroOptions"></ng-lottie>
        </div>
        <h1>Tax filing,<br /><em>stress-free.</em></h1>
        <p>
          Expert-assisted ITR filing for salaried professionals, traders &
          businesses. Starting at ₹499.
        </p>
      </div>

      <div class="auth-shell__brand-points">
        <span><i></i>Expert-Verified Returns</span>
        <span><i></i>100% Secure</span>
        <span><i></i>Hassle-free Filing</span>
        <span><i></i>Trusted Across India</span>
      </div>
    </aside>

    <div class="auth-shell__panel">
      <div
        class="auth-switcher"
        role="tablist"
        aria-label="Authentication"
        [class.auth-switcher--signup]="authSection === 'signup'"
      >
        <div class="auth-switcher__slider"></div>
        <button
          type="button"
          class="auth-switcher__button"
          [class.auth-switcher__button--active]="authSection === 'login'"
          (click)="setAuthSection('login')"
        >
          Sign In
        </button>
        <button
          type="button"
          class="auth-switcher__button"
          [class.auth-switcher__button--active]="authSection === 'signup'"
          (click)="setAuthSection('signup')"
        >
          Create Account
        </button>
      </div>

      <div
        class="auth-pane"
        [class.auth-pane--hidden]="authSection !== 'login'"
        [attr.aria-hidden]="authSection !== 'login'"
      >
        <div class="auth-card">
          @if (!isOtpTriggered) {
          <div class="auth-card__header">
            <span class="auth-card__tag">Welcome back</span>
            <h2>Sign in</h2>
            <p>Access your dashboard and filed returns.</p>
          </div>

          <div class="auth-card__socials">
            <div class="auth-card__social auth-card__social--google">
              <div
                #googleButtonHost
                id="google-btn"
                class="auth-card__google-button"
              ></div>
            </div>
          </div>
          @if (googleButtonUnavailable) {
          <div class="auth-card__google-help">
            Google sign-in is temporarily unavailable. Please use OTP login.
          </div>
          }

          <div class="auth-card__divider">
            <span>or continue with email OTP</span>
          </div>

          <div class="auth-card__body">
            @if(isEmailLogin) {
            <div class="auth-card__field">
              <label for="login-email">Email address</label>
              <mat-form-field appearance="outline" class="auth-card__mat-field">
                <input
                  id="login-email"
                  matInput
                  type="email"
                  placeholder="you@example.com"
                  [formControl]="email"
                  (blur)="updateErrorMessage()"
                  required
                />
              </mat-form-field>
              @if (email.invalid) {
              <div class="auth-card__error">{{ errorMessage }}</div>
              }
            </div>
            } @else {
            <div class="auth-card__field">
              <label for="login-phone">Mobile number</label>
              <div class="auth-card__phone">
                <mat-form-field appearance="outline" class="auth-card__phone-code">
                  <input matInput readonly value="+91" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="auth-card__phone-number">
                  <input
                    id="login-phone"
                    matInput
                    type="tel"
                    placeholder="98765 43210"
                    [formControl]="phone"
                    required
                  />
                </mat-form-field>
              </div>
              @if (phone.invalid) {
              <div class="auth-card__error">Enter valid phone number</div>
              }
            </div>
            }

            <mat-checkbox
              class="auth-card__terms"
              [checked]="isTermsAndConditionsSelected"
              (change)="
                isTermsAndConditionsSelected = !isTermsAndConditionsSelected
              "
            >
              I agree to the
              <a
                href="https://mindyourtax.in/policies/terms-and-conditions/"
                target="_blank"
              >
                Terms of Service
              </a>
            </mat-checkbox>

            <button
              mat-flat-button
              class="auth-card__primary"
              (click)="triggerOtp()"
              [disabled]="!canRequestOtp()"
            >
              Send OTP
            </button>

            <p class="auth-card__meta">
              New here?
              <button type="button" (click)="setAuthSection('signup')">
                Create a free account
              </button>
            </p>
          </div>
          } @else {
          <div class="auth-card__header">
            <span class="auth-card__tag">Step 2 of 2</span>
            <h2>Verify OTP</h2>
            <p>We sent a 6-digit code to {{ loginTarget }}</p>
          </div>

          <div class="auth-card__body">
            <div class="auth-card__otp-row">
              @for (digit of otpDigits; track $index; let index = $index) {
              <mat-form-field appearance="outline" class="auth-card__otp-field">
                <input
                  class="auth-card__otp-input"
                  matInput
                  type="tel"
                  inputmode="numeric"
                  maxlength="1"
                  [value]="digit"
                  (input)="onOtpDigitInput(index, $event)"
                  (keydown)="onOtpKeyDown(index, $event)"
                  (paste)="onOtpPaste($event)"
                />
              </mat-form-field>
              }
            </div>
            @if (otp.invalid && otp.dirty) {
            <div class="auth-card__error">Enter the 6-digit OTP to continue</div>
            }

            <button
              mat-flat-button
              class="auth-card__primary"
              (click)="verifyOtp()"
              [disabled]="!otp.valid"
            >
              Verify & Continue
            </button>

            <p class="auth-card__meta">
              <button
                type="button"
                (click)="isOtpTriggered = false; resetOtpDigits()"
              >
                Change details
              </button>
            </p>
          </div>
          }
        </div>
      </div>

      <div
        class="auth-pane"
        [class.auth-pane--hidden]="authSection !== 'signup'"
        [attr.aria-hidden]="authSection !== 'signup'"
      >
        <myt-signup
          [embedded]="true"
          [remark]="'From Login Page Signup Section'"
          [title]="'Create account'"
          [subtitle]="'File your taxes with a dedicated CA.'"
        ></myt-signup>
      </div>
    </div>
  </div>
</section>
